import SESSION_RECORDING_EVENTS from "utils/session-recording-events"

declare global {
  interface Window {
    hj?: (command: string, eventName: string) => void
  }
}

export const HOTJAR_EVENTS = SESSION_RECORDING_EVENTS

export function sendHotjarEvent(eventName: string) {
  if (!eventName || typeof window.hj !== "function") return

  window.hj("event", eventName)
}
